// @flow
'use strict';

var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/web-header/~/gud/index.js
// module id = 46
// module chunks = 0